import { DtoHelper } from "dmgen-cli/util/DtoHelper";
import { Persistent } from "../../cdes-api/dto/Persistent";

export class Realm extends Persistent {

    // Properties: (placed here as documentation)
    //
    // reviewCyclePositionTypeId : number; --> ReviewCyclePositionType
    // projectId : (number | null | undefined); --> Project
    // code : string;
    // name : string;
    // description : (string | null | undefined);
    // redliningColor : (string | null | undefined);
    // signatureOnLabel : boolean;
    // labelText : (string | null | undefined);
    // validFromDate : (number | null | undefined);
    // validToDate : (number | null | undefined);
    // labelTextFieldSeq : (number | null | undefined);

    private _reviewCyclePositionTypeId : number;
    get reviewCyclePositionTypeId() : number {
        this.__checkAttributeDefinition(12, "reviewCyclePositionTypeId");
        return this._reviewCyclePositionTypeId;
    }
    set reviewCyclePositionTypeId(reviewCyclePositionTypeId : number) {
        this._reviewCyclePositionTypeId = reviewCyclePositionTypeId;
    }

    private _projectId : (number | null | undefined);
    get projectId() : (number | null | undefined) {
        this.__checkAttributeDefinition(13, "projectId");
        return this._projectId;
    }
    set projectId(projectId : (number | null | undefined)) {
        this._projectId = projectId;
    }

    private _code : string;
    get code() : string {
        this.__checkAttributeDefinition(14, "code");
        return this._code;
    }
    set code(code : string) {
        this._code = code;
    }

    private _name : string;
    get name() : string {
        this.__checkAttributeDefinition(15, "name");
        return this._name;
    }
    set name(name : string) {
        this._name = name;
    }

    private _description : (string | null | undefined);
    get description() : (string | null | undefined) {
        this.__checkAttributeDefinition(16, "description");
        return this._description;
    }
    set description(description : (string | null | undefined)) {
        this._description = description;
    }

    private _redliningColor : (string | null | undefined);
    get redliningColor() : (string | null | undefined) {
        this.__checkAttributeDefinition(17, "redliningColor");
        return this._redliningColor;
    }
    set redliningColor(redliningColor : (string | null | undefined)) {
        this._redliningColor = redliningColor;
    }

    private _signatureOnLabel : boolean;
    get signatureOnLabel() : boolean {
        this.__checkAttributeDefinition(18, "signatureOnLabel");
        return this._signatureOnLabel;
    }
    set signatureOnLabel(signatureOnLabel : boolean) {
        this._signatureOnLabel = signatureOnLabel;
    }

    private _labelText : (string | null | undefined);
    get labelText() : (string | null | undefined) {
        this.__checkAttributeDefinition(19, "labelText");
        return this._labelText;
    }
    set labelText(labelText : (string | null | undefined)) {
        this._labelText = labelText;
    }

    private _validFromDate : (number | null | undefined);
    get validFromDate() : (number | null | undefined) {
        this.__checkAttributeDefinition(20, "validFromDate");
        return this._validFromDate;
    }
    set validFromDate(validFromDate : (number | null | undefined)) {
        this._validFromDate = validFromDate;
    }

    private _validToDate : (number | null | undefined);
    get validToDate() : (number | null | undefined) {
        this.__checkAttributeDefinition(21, "validToDate");
        return this._validToDate;
    }
    set validToDate(validToDate : (number | null | undefined)) {
        this._validToDate = validToDate;
    }

    private _labelTextFieldSeq : (number | null | undefined);
    get labelTextFieldSeq() : (number | null | undefined) {
        this.__checkAttributeDefinition(22, "labelTextFieldSeq");
        return this._labelTextFieldSeq;
    }
    set labelTextFieldSeq(labelTextFieldSeq : (number | null | undefined)) {
        this._labelTextFieldSeq = labelTextFieldSeq;
    }


    public static constructPartialInstance() : Realm {
        let instance = new Realm();
        instance.__setPartialInstance(true);
        return instance;
    }

    public static constructTrackedPartialInstance(__definedAttributes : boolean[]) : Realm {
        let instance = new Realm();
        instance.__setPartialInstance(false);
        for (let definedAttribute of __definedAttributes) {
            if (!definedAttribute) {
                instance.__setPartialInstance(true);
            }
        }
        instance.__setDefinedAttributes(__definedAttributes);
        return instance;
    }

    public equals(other : Realm) : boolean {
        if (this === other) { return true; }
        if (other == null) { return false; }
        return true 
            && super.equals(other)
            && DtoHelper.areMembersEqual(this.reviewCyclePositionTypeId, other.reviewCyclePositionTypeId, "Long")
            && DtoHelper.areMembersEqual(this.projectId, other.projectId, "Long")
            && DtoHelper.areMembersEqual(this.code, other.code, "String")
            && DtoHelper.areMembersEqual(this.name, other.name, "String")
            && DtoHelper.areMembersEqual(this.description, other.description, "String")
            && DtoHelper.areMembersEqual(this.redliningColor, other.redliningColor, "String")
            && DtoHelper.areMembersEqual(this.signatureOnLabel, other.signatureOnLabel, "Boolean")
            && DtoHelper.areMembersEqual(this.labelText, other.labelText, "String")
            && DtoHelper.areMembersEqual(this.validFromDate, other.validFromDate, "UtcSeconds")
            && DtoHelper.areMembersEqual(this.validToDate, other.validToDate, "UtcSeconds")
            && DtoHelper.areMembersEqual(this.labelTextFieldSeq, other.labelTextFieldSeq, "Integer")            ;
    }

    public toString() : string {
                return "Not yet implemented."
    }

    public toJSON() : Record<string, unknown> {
        return {
            ...super.toJSON(),
            reviewCyclePositionTypeId: this._reviewCyclePositionTypeId,
            projectId: this._projectId,
            code: this._code,
            name: this._name,
            description: this._description,
            redliningColor: this._redliningColor,
            signatureOnLabel: this._signatureOnLabel,
            labelText: this._labelText,
            validFromDate: this._validFromDate,
            validToDate: this._validToDate,
            labelTextFieldSeq: this._labelTextFieldSeq,
        };
    }
}
